export default class IdentificationVerification {
	public AgreementGuid: string = '';
	public ReceivedUTC: string = '';
	public DataJSON: string = '';
}
